import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'COMPETITION',
  collections: {
    tournamentsIds: { get: 'tournaments' },
  },
});
